import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Notification.module.css';

const initialNotifications = [
  {
    id: 1,
    name: 'Akanksha Patil',
    message: 'Akanksha Patil has arrived at your home. Your maid is here!',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=200&q=80',
    time: '2 mins ago',
    unread: true,
  },
  {
    id: 2,
    name: 'Akanksha Patil',
    message: 'Akanksha Patil has arrived at your home. Your maid is here!',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=200&q=80',
    time: '1 hour ago',
    unread: false,
  },
  {
    id: 3,
    name: 'Akanksha Patil',
    message: 'Akanksha Patil has arrived at your home. Your maid is here!',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=200&q=80',
    time: 'Yesterday',
    unread: false,
  },
  {
    id: 4,
    name: 'Akanksha Patil',
    message: 'Akanksha Patil has arrived at your home. Your maid is here!',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=200&q=80',
    time: '2 days ago',
    unread: false,
  },
  {
    id: 5,
    name: 'Akanksha Patil',
    message: 'Akanksha Patil has arrived at your home. Your maid is here!',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=200&q=80',
    time: '3 days ago',
    unread: false,
  },
];

export default function Notification() {
  const navigate = useNavigate();

  const [notifications] = useState(initialNotifications);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className={styles.screenWrapper}>
      <div className={styles.deviceFrame}>
        
        {/* Header Section */}
        <header className={styles.header}>
          <button
  type="button"
  className={styles.backButton}
  onClick={handleBack}
  aria-label="Go Back"
>
            <svg 
              width="22" 
              height="18" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="#0A529B" 
              strokeWidth="2.2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M9 14L4 9l5-5" />
              <path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v1.5" />
            </svg>
          </button>
          
          <h1 className={styles.title}>Notifications</h1>
        </header>

        {/* Custom Scrollable Notification Feed */}
        <main className={styles.scrollContainer}>
          <div className={styles.notificationList}>
            {notifications.map((item) => (
              <div key={item.id} className={styles.notificationCard}>
                <div className={styles.avatarWrapper}>
                  <img 
                    src={item.avatar} 
                    alt={item.name} 
                    className={styles.avatarImage} 
                  />
                </div>
                <div className={styles.contentWrapper}>
                  <p className={styles.messageText}>{item.message}</p>
                </div>
              </div>
            ))}
          </div>
        </main>

      </div>
    </div>
  );
}